import {Schema} from "@oilstone/rest-model-repository";

class Factory {
    #schema;

    constructor() {
        this.#schema = new Schema()
    }

    make() {
        return this.#schema;
    }

    hasId() {
        this.#schema.prop('id').setType(Number).setValue(null).readOnly().primaryKey();

        return this;
    }

    selfReferential() {
        this.#schema.prop('parentId').setType(Number).setValue(null);

        return this;
    }

    sortable() {
        this.#schema.prop('sort').setType(Number).setValue(null);

        return this;
    }

    sluggable() {
        this.#schema.prop('slug').setType(String);

        return this;
    }

    hasSection() {
        this.#schema.prop('section').setType(String);

        return this;
    }

    hasTemplate() {
        this.#schema.prop('template').setType(String).setValue(null);

        return this;
    }

    hasTitle() {
        this.#schema.prop('title').setType(String);

        return this;
    }

    hasName() {
        this.#schema.prop('name').setType(String);

        return this;
    }

    hasLede() {
        this.#schema.prop('lede').setType(String);

        return this;
    }

    hasSummary() {
        this.#schema.prop('summary').setType(String);

        return this;
    }

    hasDescription() {
        this.#schema.prop('description').setType(String);

        return this;
    }

    hasBulletSummary() {
        this.#schema.prop('summaryBullets').setType(String);

        return this;
    }

    hasImage() {
        this.#schema.prop('image').setType(String).setValue(null);
        this.#schema.prop('imageAlt').setType(String).setValue(null);

        return this;
    }

    hasBody() {
        this.#schema.prop('body').setType(String);

        return this;
    }

    hasThumbnail() {
        this.#schema.prop('thumbnail').setType(String);

        return this;
    }

    hasAddress() {
        this.#schema.prop('address1').setType(String).setValue(null);
        this.#schema.prop('address2').setType(String).setValue(null);
        this.#schema.prop('address3').setType(String).setValue(null);
        this.#schema.prop('addressCity').setType(String).setValue(null);
        this.#schema.prop('addressCounty').setType(String).setValue(null);
        this.#schema.prop('addressPostcode').setType(String).setValue(null);

        return this;
    }

    hasMetadata() {
        this.#schema.prop('windowTitle').setType(String).setValue(null);
        this.#schema.prop('metaDescription').setType(String).setValue(null);
        this.#schema.prop('ogData').setType(String).setValue(null);
        this.#schema.prop('noIndex').setType(Boolean).setValue(false);

        return this;
    }

    hasYearRange() {
        this.#schema.prop('startYear').setType(Number).setValue(null);
        this.#schema.prop('endYear').setType(Number).setValue(null);

        return this;
    }

    hasDateRange() {
        this.#schema.prop('startDate').setType(String).setValue(null);
        this.#schema.prop('endDate').setType(String).setValue(null);

        return this;
    }

    publishable() {
        this.#schema.prop('isPublished').setType(Boolean).setValue(false);
        this.#schema.prop('hasUnpublishedChanges').setType(Boolean).setValue(false);

        return this;
    }

    publishableByDate() {
        this.#schema.prop('publishAt').setType(String).setValue(null);

        return this;
    }

    hasTimestamps() {
        this.#schema.prop('createdAt').setType(String).setValue(null).readOnly();
        this.#schema.prop('updatedAt').setType(String).setValue(null).readOnly();

        return this;
    }
}

export default Factory;
